<template>
  <div>
    <v-btn class="btn-sticky-locale" @click.stop="dialogLocale = !dialogLocale">
      Bahasa
    </v-btn>
    <v-btn class="btn-sticky" @click.stop="drawer = !drawer"> Menu dev </v-btn>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      style="z-index: 100"
    >
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link @click="backToHome">
          <v-list-item-content>
            <v-list-item-title>home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="gotToCheckout">
          <v-list-item-content>
            <v-list-item-title>Checkout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="goToPeyment">
          <v-list-item-content>
            <v-list-item-title>Payment</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="gotToPaymentVa">
          <v-list-item-content>
            <v-list-item-title>Payment va</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="gotToPaymentEwallet">
          <v-list-item-content>
            <v-list-item-title>Payment qris</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="gotToOrderDetail">
          <v-list-item-content>
            <v-list-item-title>order detail</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="dialogLocale" max-width="290">
      <v-card>
        <v-card-title class="title font-weight-bold">
          Pilih Bahasa
        </v-card-title>
        <v-card-text>
          <v-list>
            <template v-for="(item, index) in availableLocales">
              <v-list-item :key="item" @click="changeLocale(item)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item === "id" ? "Bahasa Indonesia" : "English" }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="index" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import orderQris from "@/assets/json/order-qris.json";
import orderVa from "@/assets/json/order-va.json";
import { mapGetters } from "vuex";
import {
  removeAllQueryParams,
  addQueryParam,
  setQueryParam,
  getPageQueryArray,
  getQueryParamByName,
  deleteQueryParam,
} from "@/utils/customQuery";
import { setLocale } from '@/utils/locale'
export default {
  name: "DevNavigation",
  data() {
    return {
      drawer: false,
      dialogLocale: false
    };
  },
  computed: {
    ...mapGetters(["getRouterData", "getLastRouterData", "getQueryRouter"]),
    availableLocales() {
      return this.$i18n.availableLocales
    },
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    getRouterData(payload) {
      console.log("router", JSON.parse(JSON.stringify(payload)));
      console.log("router", JSON.parse(JSON.stringify(payload)));
    },
    getQueryRouter(payload) {
      console.log("router getteer", JSON.parse(JSON.stringify(payload)));
    },
  },
  methods: {
    backToHome() {
      this.drawer = false;
      removeAllQueryParams();
    },
    gotToCheckout() {
      this.$store.dispatch("set_router_data", { name: "checkout" });
      this.drawer = false;
      setQueryParam("page", "checkout");
      deleteQueryParam("order_id");
    },
    goToPeyment() {
      this.$store.dispatch("set_router_data", { name: "payment" });
      this.drawer = false;
      setQueryParam("page", "payment");
      deleteQueryParam("order_id");
    },
    gotToPaymentVa() {
      this.$store.dispatch("create_order", orderVa.data);
      this.$store.dispatch("set_router_data", { name: "payment-va" });
      this.drawer = false;
      setQueryParam("page", "payment-va");
      deleteQueryParam("order_id");
    },
    gotToPaymentEwallet() {
      this.$store.dispatch("create_order", orderQris.data);
      this.$store.dispatch("set_router_data", { name: "payment-qris" });
      this.drawer = false;
      setQueryParam("page", "payment-qris");
      deleteQueryParam("order_id");
    },
    gotToOrderDetail() {
      this.$store.dispatch("create_order", orderVa.data);
      this.$store.dispatch("set_router_data", {
        name: "order-detail",
        params: { order_id: orderVa.data.id },
      });
      this.drawer = false;
      setQueryParam("page", "order-detail");
      setQueryParam("order_id", orderVa.data.id);
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      setLocale(locale)
      this.dialogLocale = false
      this.$router.go()
    }
  },
};
</script>

<style>
button.btn-sticky-locale.v-btn.v-btn--contained.theme--light.v-size--default {
  position: fixed;
  right: 1rem;
  bottom: 5rem;
  border-radius: 50px;
}
button.btn-sticky.v-btn.v-btn--contained.theme--light.v-size--default {
  position: fixed;
  right: 1rem;
  bottom: 2rem;
  border-radius: 50px;
}
</style>
